import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { authGuard } from '../../core/guards/auth.guard';
import { rolesGuard } from '../../core/guards/roles.guard';
import { AppShellComponent } from './app-shell.component';
import {
    AssetDepartment,
    BackRvdDepartment,
    BIDepartment,
    CambioDepartment,
    ConsolidationDepartment,
    FinancialPlanningDepartment,
    ImportTrackingDepartment,
    IPODepartment,
    PerformanceAndProjectsDepartament,
    WealthDepartment,
} from './app-shell.config';

const routes: Routes = [
    {
        path: '',
        component: AppShellComponent,
        canActivate: [authGuard],
        children: [
            {
                path: ImportTrackingDepartment.id,
                canActivate: [rolesGuard(ImportTrackingDepartment.roles)],
                loadChildren: () =>
                    import('../import-tracking/import-tracking.module').then(
                        (m) => m.ImportTrackingModule
                    ),
            },
            {
                path: WealthDepartment.id,
                canActivate: [rolesGuard(WealthDepartment.roles)],
                children: [
                    {
                        path: '',
                        loadChildren: () =>
                            import(
                                '../wealth-services/wealth-services.module'
                            ).then((m) => m.WealthServicesModule),
                    },
                ],
            },
            {
                path: BIDepartment.id,
                canActivate: [rolesGuard(BIDepartment.roles)],
                children: [
                    {
                        path: '',
                        loadChildren: () =>
                            import('../bi-services/bi-services.module').then(
                                (m) => m.BiServicesModule
                            ),
                    },
                ],
            },
            {
                path: AssetDepartment.id,
                canActivate: [rolesGuard(AssetDepartment.roles)],
                children: [
                    {
                        path: '',
                        loadChildren: () =>
                            import('../asset/asset.module').then(
                                (m) => m.AssetModule
                            ),
                    },
                ],
            },
            {
                path: BackRvdDepartment.id,
                canActivate: [rolesGuard(BackRvdDepartment.roles)],
                children: [
                    {
                        path: '',
                        loadChildren: () =>
                            import('../back-rvd/back-rvd.module').then(
                                (m) => m.BackRvdModule
                            ),
                    },
                ],
            },
            {
                path: IPODepartment.id,
                canActivate: [rolesGuard(IPODepartment.roles)],
                children: [
                    {
                        path: '',
                        loadChildren: () =>
                            import('../ipos/ipo.module').then(
                                (m) => m.IpoModule
                            ),
                    },
                ],
            },
            {
                path: PerformanceAndProjectsDepartament.id,
                canActivate: [
                    rolesGuard(PerformanceAndProjectsDepartament.roles),
                ],
                children: [
                    {
                        path: '',
                        loadChildren: () =>
                            import(
                                '../performance-and-projects/performance-and-projects.module'
                            ).then((m) => m.PerformanceAndProjectsModule),
                    },
                ],
            },
            {
                path: CambioDepartment.id,
                canActivate: [rolesGuard(CambioDepartment.roles)],
                children: [
                    {
                        path: '',
                        loadChildren: () =>
                            import('../cambio/cambio.module').then(
                                (m) => m.CambioModule
                            ),
                    },
                ],
            },
            {
                path: FinancialPlanningDepartment.id,
                canActivate: [rolesGuard(FinancialPlanningDepartment.roles)],
                children: [
                    {
                        path: '',
                        loadChildren: () =>
                            import(
                                '../financial-planning/financial-planning.module'
                            ).then((m) => m.FinancialPlanningModule),
                    },
                ],
            },
            {
                path: ConsolidationDepartment.id,
                canActivate: [rolesGuard(ConsolidationDepartment.roles)],
                children: [
                    {
                        path: '',
                        loadChildren: () =>
                            import(
                                '../consolidation/consolidation.module'
                            ).then((m) => m.ConsolidationModule),
                    },
                ],
            },
        ],
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class AppShellRoutingModule {}
